import {
  Dialog,
  DialogBackdrop,
  DialogPanel,
  DialogTitle,
} from "@headlessui/react";
import { XMarkIcon } from "@heroicons/react/24/outline";
import { useState } from "react";
import { EyeIcon } from "@heroicons/react/20/solid";
import { PromissoryV1 } from "../../../legal/Agreements/PromissoryV1";

export function ViewPromissory({
  basicInfo,
  userinfo
}) {
  const [open, setOpen] = useState(false);

  return (
    <>
      <div onClick={() => setOpen(true)}>
        <div className="cursor-pointer min-w-full">
          <div className="flex text-purple underline">
            {" "}
            <EyeIcon className="w-4 h-auto" /> Ver pagaré{" "}
          </div>
        </div>
      </div>
      <Dialog open={open} onClose={setOpen} className="relative z-50">
        <DialogBackdrop
          transition
          className="fixed inset-0 bg-darkBgLight bg-opacity-75 transition-opacity duration-200 ease-in-out data-[closed]:opacity-0"
        />

        <div className="fixed inset-x-0 overflow-hidden">
          <div className="absolute inset-0 overflow-hidden">
            <div className="pointer-events-none fixed md:inset-y-0 bottom-0 md:right-0 flex max-w-full md:pl-10">
              <DialogPanel
                transition
                className="pointer-events-auto w-screen md:max-w-lg transform h-128 md:h-full transition duration-300 ease-in-out data-[closed]:translate-y-full"
              >
                <div className="flex h-full flex-col rounded-t-3xl md:rounded-none bg-darkBg tracking-tight font-walsheim">
                  <div className="">
                    <div className="py-6">
                      <div className="flex justify-between px-4 pt-2 md:pt-8">
                        <DialogTitle>
                          <div className="text-white">
                            Pagaré y carta de instrucciones
                          </div>
                        </DialogTitle>
                        <div className="flex h-7 items-center">
                          <button
                            type="button"
                            onClick={() => setOpen(false)}
                            className="relative text-white focus:outline-none"
                          >
                            <span className="absolute" />
                            <span className="sr-only">Close panel</span>
                            <XMarkIcon aria-hidden="true" className="h-6 w-6" />
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="h-full rounded-t-3xl bg-white overflow-auto">
                    <PromissoryV1 basicInfo={basicInfo} userinfo={userinfo}/>
                  </div>
                </div>
              </DialogPanel>
            </div>
          </div>
        </div>
      </Dialog>
    </>
  );
}
